define('app/sdc/debugging/enabled/sdc-debugging-enabled',[], function () {
	return {
		restrict: "A",
		scope: false,
		template: null,
		controller: {
			constructor: ["$attrs", "$self", function ($attrs, vm) {
				$attrs.$observe("sdcDebuggingEnabled", (function (value) {
					vm.state = value;
				}));
			}]
		}
	};
});
